import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const SOCKET_PARAM = "socket_details";
// Both tabs share these filters, so switching tabs keeps the time range.
export const SOCKET_DETAILS_FILTER_PREFIX = "socket";

export const useSocketDetails = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const open = useCallback(
    (socketId: string) =>
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.set(SOCKET_PARAM, socketId);
          return next;
        },
        { replace: true },
      ),
    [setSearchParams],
  );

  const close = useCallback(
    () =>
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.delete(SOCKET_PARAM);
          [...next.keys()]
            .filter((key) => key.startsWith(`${SOCKET_DETAILS_FILTER_PREFIX}_`))
            .forEach((key) => next.delete(key));
          return next;
        },
        { replace: true },
      ),
    [setSearchParams],
  );

  return { socketId: searchParams.get(SOCKET_PARAM), open, close };
};
